import store from "../store/index.js";
import Vue from "vue";
import graph from "@/graph.js";
import qs from "qs";

export default {
  async getUserProfile() {
    let user = await graph.getUserProfile();

    store.dispatch("updateUser", user);
    return user;
  },
  async getUserPhoto() {
    let photo = null;

    photo = await graph.getPhoto();


    store.dispatch("updateUserPhoto", photo);

    return photo;
  },
  async setAdminStatus(groupObjectIds) {
    let groups = await this.getGroups(groupObjectIds);
    let divisions = null;
    let businessUnitIds = null;

    let isAdmin = false;
    let readOnly = false;
    if (groups !== null && groups.length > 0) {
      divisions = groups.map(g=> g.Division);
      isAdmin = groups.filter(g => g.IsAdmin).length > 0;
      readOnly = groups.filter(g => g.ReadOnly).length > 0;
      businessUnitIds =  groups.map(g=> g.BusinessUnitId);

      await this.setStoreAdminStatus(isAdmin);
      await this.setReadOnlyStatus(readOnly);
      await this.updateDivision(divisions);
      await this.updateBusinessUnitId(businessUnitIds);
    }
    //isExports = x[0].isExports;
    //}
    // } else {
    //BU admin
    //division = x[0].division;
    //isAdmin = true;
    //isExports = false;
    //}
    //await this.setExportsStatus(isExports);

  },
  async getGroups(objectIds) {
    try {
      var response = await Vue.prototype.$axios.post(
        "roles/getdivisionadobject",       
          objectIds
      );
      return response.data;
    } catch (error) {
      console.error(error);
    }

    return null;
  },
  // async getDivision() {
  //   return await Vue.prototype.$database.get("settings", "division");
  // },
  async getAdminStatus() {
    let status = store.getters.isAdmin;

    return status;
  },
  async setReadOnlyStatus(readOnly) {
    store.dispatch("setReadOnlyStatus", readOnly);
  },
  async setStoreAdminStatus(isAdmin) {
    store.dispatch("setAdminStatus", isAdmin);
  },
  async updateDivision(divisions) {
    store.dispatch("updateDivision", divisions);
  },
  async updateBusinessUnitId(businessUnitIds) {
    store.dispatch("updateBusinessUnitId", businessUnitIds);
  },
  // async getExportsStatus() {
  //   return await Vue.prototype.$database.get("settings", "isExports");
  // },
  // async setExportsStatus(isExports) {
  //   await Vue.prototype.$database.put("settings", "isExports", isExports);
  //   store.dispatch("setExportStatus", isExports);
  // },
  // async getDarkMode() {
  //   return (await Vue.prototype.$database.get("settings", "darkMode")) ?? false;
  // },
  // async setDarkMode(status) {
  //   await Vue.prototype.$database.put("settings", "darkMode", status);
  // },
};
